import { AmplitudeExtendableEvent } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';

export const CONTEXT_SHOWN__PURCHASE_WINDOW__EVENT: AmplitudeExtendableEvent = {
  action: 'Context Shown',
  additionalProperties: {
    context: 'Purchase Window',
  },
};

export const TRANSFER_PURCHASE_FUNNEL__PAYMENT_INITIATED__EVENT: AmplitudeExtendableEvent =
  {
    action: 'Transfer Purchase Funnel',
    additionalProperties: {
      Step: 'Payment Initiated',
    },
  };

export const BUYER_TERMS_PDF_PATH =
  '/documents/Paid_Transfer_Terms_&_Privacy_Notice.pdf';

// We're not translating for Alpha release
export const BUY_BUTTON_LABEL = 'Buy now';
